/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu'
import { LinqService, QueryOptions } from 'linquest'
import {
  PreviousPerformanceFormDto,
  CombinedPerformanceFormDetailViewModel,
  PreviousPerformanceFormViewModel,
  SavePreviousPerformanceFormViewModel
} from './models'

/**
 * PreviousPerformanceFormApi - API class
 */
export class PreviousPerformanceFormApi extends LinqService {
  /**
   * Creates a new PreviousPerformanceFormApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider)
  }

  /**
   * @param dto
   */
  addOrUpdateAsync(dto?: PreviousPerformanceFormDto, options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceForm/AddOrUpdateAsync`
    let query = this.createQuery<any>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set body parameter
    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceForm/DeleteAsync`
    let query = this.createQuery<any>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceForm/GetAsync`
    let query = this.createQuery<PreviousPerformanceFormDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param formId
   */
  getPerformanceForm(formId?: string, options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceForm/GetPerformanceForm`
    let query = this.createQuery<CombinedPerformanceFormDetailViewModel>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'formId', value: formId && formId.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * Get performance form details for multiple forms
   * @param formIds Array of form IDs
   */
  getPerformanceFormsDetails(formIds?: Array<string>, options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceForm/GetPerformanceFormsDetails`
    let query = this.createQuery<CombinedPerformanceFormDetailViewModel>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.data = formIds
    query = query.withOptions(options)

    return query
  }

  /**
   * @param id
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceForm/GetTranslatedAsync`
    let query = this.createQuery<PreviousPerformanceFormDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceForm/List`
    let query = this.createQuery<PreviousPerformanceFormDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    query = query.withOptions(options)

    return query
  }

  /**
   * @param employeeId
   */
  listPerformanceFormOfEmployee(employeeId?: string, options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceForm/ListPerformanceFormOfEmployee`
    let query = this.createQuery<PreviousPerformanceFormViewModel>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'employeeId', value: employeeId && employeeId.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceForm/ListTranslated`
    let query = this.createQuery<PreviousPerformanceFormDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    query = query.withOptions(options)

    return query
  }

  /**
   * @param dto
   */
  saveAsync(dto?: PreviousPerformanceFormDto, options?: QueryOptions) {
    // create query
    const url = `/PreviousPerformanceForm/SaveAsync`
    let query = this.createQuery<any>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set body parameter
    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param savePreviousPerformanceFormViewModel
   */
  savePreviousPerformanceForm(
    savePreviousPerformanceFormViewModel?: Array<SavePreviousPerformanceFormViewModel>,
    options?: QueryOptions
  ) {
    // create query
    const url = `/PreviousPerformanceForm/SavePreviousPerformanceForm`
    let query = this.createQuery<any>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set body parameter
    options.data = savePreviousPerformanceFormViewModel
    query = query.withOptions(options)

    return query.firstAsync()
  }
}
